<template>
  <div class="dashboard">
    <div class="row">
      <div class="col-12">
        <h4>รายงานค่า P ผู้สมัคร</h4>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 table-responsive">
        <div>
          <table class="table agent-table">
            <thead>
              <tr>
                <th>Admin</th>
                <th class="text-center">P-00</th>
                <th class="text-center">P-40</th>
                <th class="text-center">P-50</th>
                <th class="text-center">P-80</th>
                <th class="text-center">P-80 Plus</th>
                <th class="text-center">P-90</th>
                <th class="text-center">P-100</th>
                <th class="text-center">รวม</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in report" :key="index">
                <td>
                  <template v-if="item.admin">
                    <img :src="item.admin.profile_picture" class="rounded-circle img-circle-sm mr-2" width="32" alt=""> {{ item.admin.name }}
                  </template>
                </td>
                <td class="text-center">
                  {{ item['P-00'] }}
                </td>
                <td class="text-center">
                  {{ item['P-40'] }}
                </td>
                <td class="text-center">
                  {{ item['P-50'] }}
                </td>
                <td class="text-center">
                  {{ item['P-80'] }}
                </td>
                <td class="text-center">
                  {{ item['P-80 Plus'] }}
                </td>
                <td class="text-center">
                  {{ item['P-90'] }}
                </td>
                <td class="text-center">
                  {{ item['P-100'] }}
                </td>
                <td class="text-center">
                  {{ item.total }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      report: []
    }
  },
  computed: {
    ...mapState('admin', ['admin'])
  },
  methods: {
    async getReport () {
      const res = await axios.get('reports/p')
      if (res.status === 200) {
        this.report = res.data.report
      } else {
        this.report = []
      }
    }
  },
  sockets: {
    newActivity (data) {
      this.customerAdmins = data.customerAdmins
      this.professionalAdmins = data.professionalAdmins
    }
  },
  mounted () {
    this.getReport()
  }
}
</script>

<style lang="scss" scoped>
div.dashboard {
  padding: 1rem;
}
.agent-table {
  font-size: 0.8rem;
}
.agent-table th {
  border-top: hidden;
}
</style>
